import { useState, useEffect } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import api from "../../../services/api";
import Template from "../../../template";
import { toast } from "react-toastify";
import ChatDanizinha from "../../../components/ChatDanizinha";
import DanizinhaImg from "../../../assets/img/Danizinha_img.png";
import { useCorrecao } from "../../../context/correcao";

import * as S from "./styled";

function CorrecaoTeste(props) {
  const { id } = props.match.params;
  const history = useHistory();
  const { correcaoData: contextCorrecaoData, imageData, clearCorrecaoData } = useCorrecao();

  const [correcaoData, setCorrecaoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [chatNotification, setChatNotification] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typingMessage, setTypingMessage] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [showTyping, setShowTyping] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [printError, setPrintError] = useState(null);
  const [printUrl, setPrintUrl] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");
  const [imageModalAlt, setImageModalAlt] = useState("");
  const [showFullImage, setShowFullImage] = useState(false);
  const [fullImageSrc, setFullImageSrc] = useState("");
  const [fullImageAlt, setFullImageAlt] = useState("");

  useEffect(() => {
     function getCorrecaoFromContext() {
       console.log('CorrecaoTeste - Carregando dados da correção do contexto');
       
       try {
         if (contextCorrecaoData) {
           console.log('CorrecaoTeste - Dados da correção encontrados no contexto:', contextCorrecaoData);
           // Criar objeto compatível com o formato anterior
           const correcaoFormatada = {
             ...contextCorrecaoData,
             redacao_image: imageData // Manter compatibilidade
           };
           setCorrecaoData(correcaoFormatada);
         } else {
           console.log('CorrecaoTeste - Nenhum dado de correção encontrado no contexto');
           setError('Dados da correção não encontrados');
           toast.error("Dados da correção não encontrados. Tente enviar a redação novamente.");
         }
       } catch (error) {
         console.error('Erro ao carregar dados da correção:', error);
         setError('Erro ao carregar dados da correção');
         toast.error("Erro ao carregar dados da correção");
       } finally {
         setLoading(false);
       }
     }
 
     // Carregar os dados do contexto
     getCorrecaoFromContext();
   }, [contextCorrecaoData, imageData]);

  const getCompetenciaColor = (nota) => {
    if (nota >= 160) return "success";
    if (nota >= 120) return "warning";
    return "danger";
  };

  const formatarNota = (nota) => {
    return nota ? nota.toString() : '0';
  };

  const formatarComentario = (texto) => {
    if (!texto) return "Nenhum comentário específico";
    
    const secoes = texto.split('|').map(secao => secao.trim());
    
    return secoes.map((secao, index) => (
      <div key={index} style={{ marginBottom: '15px' }}>
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '10px', 
          borderRadius: '5px',
          borderLeft: '4px solid #007bff'
        }}>
          {secao}
        </div>
      </div>
    ));
  };

  if (loading) {
    return (
      <Template>
        <Container>
          <Row>
            <Col className="text-center mt-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3">Carregando correção de teste...</p>
            </Col>
          </Row>
        </Container>
      </Template>
    );
  }

  if (!correcaoData) {
    return (
      <Template>
        <Container>
          <Row>
            <Col className="text-center mt-5">
              <h3>Correção de teste não encontrada</h3>
              <button 
                className="btn btn-primary mt-3"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </Col>
          </Row>
        </Container>
      </Template>
    );
  }

  return (
    <Template>
      <S.MainWrapper>
        <Container>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <Row>
                  <Col>
                    <S.Header>
                      <h2>Correção da Redação de Teste - Inteligência Artificial</h2>
                      <S.NotaFinal>
                        Nota Final: <span>{correcaoData.final_score}</span>
                      </S.NotaFinal>
                    </S.Header>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Card className="mb-4">
                      <Card.Header>
                        <h5>Competências</h5>
                      </Card.Header>
                      <Card.Body>
                        <S.CompetenciaItem>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>Competência 1:</strong></span>
                            <Badge variant={getCompetenciaColor(correcaoData.competencies?.competencia_1)}>
                              {formatarNota(correcaoData.competencies?.competencia_1)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill 
                              width={(correcaoData.competencies?.competencia_1 / 200) * 100} 
                              color={getCompetenciaColor(correcaoData.competencies?.competencia_1)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                        
                        <S.CompetenciaItem>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>Competência 2:</strong></span>
                            <Badge variant={getCompetenciaColor(correcaoData.competencies?.competencia_2)}>
                              {formatarNota(correcaoData.competencies?.competencia_2)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill 
                              width={(correcaoData.competencies?.competencia_2 / 200) * 100} 
                              color={getCompetenciaColor(correcaoData.competencies?.competencia_2)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                        
                        <S.CompetenciaItem>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>Competência 3:</strong></span>
                            <Badge variant={getCompetenciaColor(correcaoData.competencies?.competencia_3)}>
                              {formatarNota(correcaoData.competencies?.competencia_3)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill 
                              width={(correcaoData.competencies?.competencia_3 / 200) * 100} 
                              color={getCompetenciaColor(correcaoData.competencies?.competencia_3)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                        
                        <S.CompetenciaItem>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>Competência 4:</strong></span>
                            <Badge variant={getCompetenciaColor(correcaoData.competencies?.competencia_4)}>
                              {formatarNota(correcaoData.competencies?.competencia_4)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill 
                              width={(correcaoData.competencies?.competencia_4 / 200) * 100} 
                              color={getCompetenciaColor(correcaoData.competencies?.competencia_4)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                        
                        <S.CompetenciaItem>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>Competência 5:</strong></span>
                            <Badge variant={getCompetenciaColor(correcaoData.competencies?.competencia_5)}>
                              {formatarNota(correcaoData.competencies?.competencia_5)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill 
                              width={(correcaoData.competencies?.competencia_5 / 200) * 100} 
                              color={getCompetenciaColor(correcaoData.competencies?.competencia_5)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Card className="mb-4">
                      <Card.Header>
                        <h5>Comentários por Competência</h5>
                      </Card.Header>
                      <Card.Body>
                        <S.ComentarioItem>
                          <strong>Competência 1:</strong>
                          <div>{formatarComentario(correcaoData.comments?.competencia_1)}</div>
                        </S.ComentarioItem>
                        <S.ComentarioItem>
                          <strong>Competência 2:</strong>
                          <div>{formatarComentario(correcaoData.comments?.competencia_2)}</div>
                        </S.ComentarioItem>
                        <S.ComentarioItem>
                          <strong>Competência 3:</strong>
                          <div>{formatarComentario(correcaoData.comments?.competencia_3)}</div>
                        </S.ComentarioItem>
                        <S.ComentarioItem>
                          <strong>Competência 4:</strong>
                          <div>{formatarComentario(correcaoData.comments?.competencia_4)}</div>
                        </S.ComentarioItem>
                        <S.ComentarioItem>
                          <strong>Competência 5:</strong>
                          <div>{formatarComentario(correcaoData.comments?.competencia_5)}</div>
                        </S.ComentarioItem>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {(correcaoData.redacao_image || correcaoData.text) && (
                  <Row>
                    <Col>
                      <Card>
                        <Card.Header>
                          <h5>{correcaoData.redacao_image ? 'Imagem da Redação' : 'Texto da Redação'}</h5>
                        </Card.Header>
                        <Card.Body>
                          {correcaoData.redacao_image ? (
                            <div className="text-center">
                              <img 
                                src={correcaoData.redacao_image} 
                                alt="Redação" 
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '1200px', 
                                  border: '1px solid #ddd',
                                  borderRadius: '8px',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }} 
                              />
                            </div>
                          ) : (
                            <div style={{ whiteSpace: 'pre-wrap', fontSize: '16px', lineHeight: '1.6' }}>
                              {correcaoData.text}
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4">
                  <Col className="text-center">
                    <button 
                      className="btn btn-secondary mr-3"
                      onClick={() => history.goBack()}
                    >
                      Voltar
                    </button>
                  </Col>
                </Row>
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>

      {/* Botão flutuante para toggle do chat
      {!showChat && (
        <S.FloatingButton onClick={() => {
          setShowChat(true);
        }}>
          <S.FloatingButtonImage src={DanizinhaImg} alt="Danizinha" />
        </S.FloatingButton>
      )} */}

      {/* Chat da Danizinha */}
      {/* <ChatDanizinha 
          show={showChat}
          onHide={() => setShowChat(false)}
          redacaoId={"teste"}
          correcaoData={correcaoData}
        /> */}
    </Template>
  );
}

export default CorrecaoTeste;